import React from 'react';
import PropTypes from 'prop-types';
import { PAYOUT_REASON_LABELS } from './payoutCsv';
import { COLORS, thStyle, tdStyle } from './constants';
import { Colors } from '../../../themes/colors';

// The scrollable "Professional ID / Reason" table shared by the submission
// summary (BE-skipped rows). Presentational only.
export const SkippedPayoutsTable = ({ rows }) => (
  <div
    style={{
      maxHeight: 260,
      overflowY: 'auto',
      border: `1px solid ${COLORS.border}`,
    }}
  >
    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
      <thead>
        <tr style={{ backgroundColor: COLORS.headerBg }}>
          <th style={thStyle}>Professional ID</th>
          <th style={thStyle}>Reason</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((row, index) => {
          // The BE returns no per-row id and the same professional may repeat,
          // so the row's position is the stable key for this render-once,
          // never-reordered list.
          // eslint-disable-next-line react/no-array-index-key
          const rowKey = `skipped-${index}`;

          return (
            <tr key={rowKey} style={{ borderTop: `1px solid ${COLORS.border}` }}>
              <td style={tdStyle}>{row.professionalId || '—'}</td>
              <td style={{ ...tdStyle, color: Colors.error_500 }}>
                {PAYOUT_REASON_LABELS[row.reason] || row.reason}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  </div>
);

SkippedPayoutsTable.propTypes = {
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      professionalId: PropTypes.string,
      reason: PropTypes.string,
    }),
  ).isRequired,
};
